// extracted by mini-css-extract-plugin
export var description = "product-box-module--description--c2d76";
export var image = "product-box-module--image--5d46b";
export var imageContainer = "product-box-module--imageContainer--4c668";
export var link = "product-box-module--link--4fb65";
export var plate = "product-box-module--plate--5be49";
export var product = "product-box-module--product--eb556";
export var productContainer = "product-box-module--productContainer--a865c";
export var shadow = "product-box-module--shadow--a2202";